import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'app-taxonomy-documentation',
  template: `
    <mat-card>
      <h2>
        Taxonomy presentation structure
      </h2>
      <h4>
        What is it?
      </h4>
      <p>You can manage, create, edit, delete and attach segments here to Taxonomy entities that resemble a
        tree-like structure.
        Taxonomy currently is used only for presentational purposes, you can attach/detach segments from
        particular taxonomies as much as you like and it won't affect any shares or segment names.
      </p>
      <h4>
        How to view segments in taxonomy structure?
      </h4>
      <p>Go to /segments (<i>Segments</i> tab in top navigation bar) and select Hierarchical view mode</p>
      <h4>What can I do here?</h4>
      <p>You can start with creating a 'root level' taxonomy, so the taxonomy that is a root of the taxonomy tree.
        For example: given taxonomy <b>emetriq automotive > diesel > audi</b> the <b><i>emetriq automotive</i></b>
        is
        root taxonomy, where as <b><i>diesel</i></b> is a child of <b><i>emetriq automotive</i></b> and
        <b><i>audi</i></b>
        is a child
        of <b><i>diesel</i></b></p>
    </mat-card>
  `,
  styleUrls: ['./taxonomy-documentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaxonomyDocumentationComponent {


}
